export default [
  {
    path: "/app/school-transport",
    component: () => import("../views"),
    meta: {
      title: "Educasis - Transporte Escolar",
      requiresAuth: true,

    },
    children: [
      // Register

      /* Enterprises */
      {
        path: "register/enterprises",
        name: "school-transport.register.enterprises",
        component: () => import("../register/enterprises/views/List.vue"),
        meta: {
          permission: "view_enterprise",
        },
      },
      {
        path: "register/enterprises/create",
        name: "school-transport.register.enterprises.create",
        component: () => import("../register/enterprises/views/Create.vue"),
        meta: {
          permission: "view_enterprise",
        },
      },
      {
        path: "register/enterprises/edit/:id",
        name: "school-transport.register.enterprises.edit",
        component: () => import("../register/enterprises/views/Edit.vue"),
        meta: {
          permission: "view_enterprise",
        },
      },
      {
        path: "register/enterprises/show/:id",
        name: "school-transport.register.enterprises.show",
        component: () => import("../register/enterprises/views/Show.vue"),
        meta: {
          permission: "view_enterprise",
        },
      },
      /* Drivers */
      {
        path: "register/drivers",
        name: "school-transport.register.drivers",
        component: () => import("../register/drivers/views/List.vue"),
        meta: {
          permission: "view_driver",
        },
      },
      {
        path: "register/drivers/create",
        name: "school-transport.register.drivers.create",
        component: () => import("../register/drivers/views/Create.vue"),
        meta: {
          permission: "view_driver",
        },
      },
      {
        path: "register/drivers/edit/:id",
        name: "school-transport.register.drivers.edit",
        component: () => import("../register/drivers/views/Edit.vue"),
        meta: {
          permission: "view_driver",
        },
      },
      {
        path: "register/drivers/show/:id",
        name: "school-transport.register.drivers.show",
        component: () => import("../register/drivers/views/Show.vue"),
        meta: {
          permission: "view_driver",
        },
      },
      /* Points */
      {
        path: "register/points",
        name: "school-transport.register.points",
        component: () => import("../register/points/views/List.vue"),
        meta: {
          permission: "view_point",
        },
      },
      {
        path: "register/points/create",
        name: "school-transport.register.points.create",
        component: () => import("../register/points/views/Create.vue"),
        meta: {
          permission: "view_point",
        },
      },
      {
        path: "register/points/edit/:id",
        name: "school-transport.register.points.edit",
        component: () => import("../register/points/views/Edit.vue"),
        meta: {
          permission: "view_point",
        },
      },
      {
        path: "register/points/show/:id",
        name: "school-transport.register.points.show",
        component: () => import("../register/points/views/Show.vue"),
        meta: {
          permission: "view_point",
        },
      },
      /* Routes */
      {
        path: "register/routes",
        name: "school-transport.register.routes",
        component: () => import("../register/routes/views/List.vue"),
        meta: {
          permission: "view_route",
        },
      },
      {
        path: "register/routes/create",
        name: "school-transport.register.routes.create",
        component: () => import("../register/routes/views/Create.vue"),
        meta: {
          permission: "view_route",
        },
      },
      {
        path: "register/routes/edit/:id",
        name: "school-transport.register.routes.edit",
        component: () => import("../register/routes/views/Edit.vue"),
        meta: {
          permission: "view_route",
        },
      },
      {
        path: "register/routes/show/:id",
        name: "school-transport.register.routes.show",
        component: () => import("../register/routes/views/Show.vue"),
        meta: {
          permission: "view_route",
        },
      },
      /* Itineraries */
      {
        path: "register/itineraries/create/:id",
        name: "school-transport.register.itineraries.create",
        component: () => import("../register/itineraries/views/Create.vue"),
      },
      {
        path: "register/itineraries/edit/:id",
        name: "school-transport.register.itineraries.edit",
        component: () => import("../register/itineraries/views/Edit.vue"),
      },
      /* Vehicles */
      {
        path: "register/vehicles",
        name: "school-transport.register.vehicles",
        component: () => import("../register/vehicles/views/List.vue"),
        meta: {
          permission: "view_vehicle",
        },
      },
      {
        path: "register/vehicles/create",
        name: "school-transport.register.vehicles.create",
        component: () => import("../register/vehicles/views/Create.vue"),
        meta: {
          permission: "view_vehicle",
        },
      },
      {
        path: "register/vehicles/edit/:id",
        name: "school-transport.register.vehicles.edit",
        component: () => import("../register/vehicles/views/Edit.vue"),
        meta: {
          permission: "view_vehicle",
        },
      },
      {
        path: "register/vehicles/show/:id",
        name: "school-transport.register.vehicles.show",
        component: () => import("../register/vehicles/views/Show.vue"),
        meta: {
          permission: "view_vehicle",
        },
      },

      // movements
      /* copy-route */
      {
        path: "movements/copy-route",
        name: "school-transport.movements.copy-route",
        component: () => import("../movements/copy-route/views/Create.vue"),
        meta: {
          permission: "add_route",
        },
      },
      /* persons-transports */
      {
        path: "movements/persons-transports",
        name: "school-transport.movements.persons-transports",
        component: () =>
          import("../movements/persons-transports/views/List.vue"),
        meta: {
          permission: "add_person_transport",
        },
      },
      {
        path: "movements/persons-transports/create",
        name: "school-transport.movements.persons-transports.create",
        component: () =>
          import("../movements/persons-transports/views/Create.vue"),
        meta: {
          permission: "add_person_transport",
        },
      },
      {
        path: "movements/persons-transports/edit/:id",
        name: "school-transport.movements.persons-transports.edit",
        component: () =>
          import("../movements/persons-transports/views/Edit.vue"),
        meta: {
          permission: "add_person_transport",
        },
      },
      {
        path: "movements/persons-transports/show/:id",
        name: "school-transport.movements.persons-transports.show",
        component: () =>
          import("../movements/persons-transports/views/Show.vue"),
        meta: {
          permission: "add_person_transport",
        },
      },

      // reports
      /* drivers */
      {
        path: "reports/registers/drivers",
        name: "school-transport.reports.registers.drivers",
        component: () => import("../reports/registers/drivers/views/List.vue"),
        meta: {
          permission: "view_report_driver",
        },
      },
      /* routes */
      {
        path: "reports/registers/routes",
        name: "school-transport.reports.registers.routes",
        component: () => import("../reports/registers/routes/views/List.vue"),
        meta: {
          permission: "view_report_route",
        },
      },
      /* users */
      {
        path: "reports/registers/users",
        name: "school-transport.reports.registers.users",
        component: () => import("../reports/registers/users/views/List.vue"),
        meta: {
          permission: "view_report_person_transport",
        },
      },
    ],
  },
];
